import { render, staticRenderFns } from "./ReSearchTaskStaff.vue?vue&type=template&id=0e73d3a9&scoped=true"
import script from "./ReSearchTaskStaff.vue?vue&type=script&lang=js"
export * from "./ReSearchTaskStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e73d3a9",
  null
  
)

export default component.exports